import { createActions, handleActions } from 'redux-actions';
import Notifications from 'react-notification-system-redux';

import {
    defaultPaginationData,
    getPaginationAndOrderData,
} from '../../shared/utils';

const actions = createActions({
    TO_LET_BOARDS: {
        LIST: {
            FILTER: filter => ({ filter }),
            FETCHING: currentPage => ({ currentPage }),
            LOADED: list => ({ list }),
        },
        STATUS: {
            CHANGING: undefined,
            CHANGED: undefined,
        },
    },
});

const initialState = {
    list: Object.assign(
        {},
        {
            filter: null,
            error: null,
            fetching: false,
            fetchingTime: null,
            boards: null,
            currentPage: 1,
        },
        defaultPaginationData
    ),
    statusChange: {
        changing: false,
        changed: false,
    },
    shared: {
        instructions: {
            ERECT: 'Erect',
            REMOVE: 'Remove',
        },
        type: {
            '4x3_STANDARD_FLAT_BOARD': "4' x 3' Standard Flat Board",
            '4x3_V_FORMATION_BOARD': "4' x 3' 'V' Formation Board",
        },
        placement: {
            FIXED_TO_STRUCTURE: 'Fixed to Structure',
            FREE_STANDING: 'Free Standing',
        },
    },
};

let fetchingTimer;

export default handleActions(
    {
        [actions.toLetBoards.list.filter]: (state, action) => {
            return Object.assign({}, state, {
                list: Object.assign({}, state.list, {
                    filter: action.payload.filter,
                }),
            });
        },

        [actions.toLetBoards.list.fetching]: (state, action) => {
            fetchingTimer = Date.now();

            return Object.assign({}, state, {
                list: Object.assign({}, state.list, {
                    fetching: true,
                    currentPage: action.payload.currentPage,
                }),
            });
        },

        [actions.toLetBoards.list.loaded]: {
            next: (state, action) => {
                fetchingTimer = Date.now() - fetchingTimer;

                return Object.assign({}, state, {
                    list: Object.assign(
                        {},
                        state.list,
                        getPaginationAndOrderData(action.payload.list.meta),
                        {
                            boards: action.payload.list.results.reduce(
                                (result, toLetBoard) => {
                                    result[
                                        toLetBoard.toLetBoardId
                                    ] = toLetBoard;
                                    return result;
                                },
                                {}
                            ),
                            fetching: false,
                            fetchingTime: fetchingTimer,
                        }
                    ),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, state, {
                    list: Object.assign({}, initialState.list, {
                        error: true,
                    }),
                });
            },
        },
    },
    initialState
);

export const filterToLetBoards = filter => {
    return actions.toLetBoards.list.filter(filter);
};

export const loadToLetBoards = (currentPage, limit = 25) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        const filter = getState().toletboards.list.filter || '';
        dispatch(actions.toLetBoards.list.fetching({ currentPage }));

        return api
            .get(
                `/toletboards?limit=${limit}&page=${currentPage}&filter=${filter}`
            )
            .then(
                response =>
                    dispatch(actions.toLetBoards.list.loaded(response.data)),
                err => dispatch(actions.toLetBoards.list.loaded(err))
            );
    };
};

export const changeToLetBoardStatus = (boardId, status) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.toLetBoards.status.changing());

        return api.put(`/toletboards/${boardId}/${status.toLowerCase()}`).then(
            response => {
                dispatch(actions.toLetBoards.status.changed(response.data));

                dispatch(
                    Notifications.success({
                        title: 'Status Changed',
                        message: `The status has changed to ${status.toLowerCase()}.`,
                        position: 'tc',
                        autoDismiss: 3,
                    })
                );
            },
            err => {
                dispatch(actions.toLetBoards.status.changed(err));
                dispatch(
                    Notifications.error({
                        title: 'Status change failed',
                        message:
                            'An error occurred whilst changing the to let board status. Please try again.',
                        position: 'tc',
                        autoDismiss: 5,
                    })
                );
                throw err;
            }
        );
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/toletboards.js